import React from "react";

import "./TeamCard.scss";
import placeholderAvatar from "../../assets/images/placeholder-avatar.svg";

export default function TeamCard({cardInfo, isDark}) {
  function openUrlInNewTab(url, name) {
    if (!url) {
      console.log(`URL for ${name} not found`);
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const imageSrc = cardInfo.image || placeholderAvatar;

  return (
    <div className={isDark ? "dark-mode certificate-card" : "certificate-card"}>
      <div className="certificate-image-div">
        <img
          src={imageSrc}
          alt={cardInfo.imageAlt || "Card Thumbnail"}
          className="card-image"
          onError={e => {
            e.target.src = placeholderAvatar;
          }}
        ></img>
      </div>
      <div className="certificate-detail-div">
        <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
          {cardInfo.title}
        </h5>
        <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>
          {cardInfo.description}
        </p>
        {cardInfo.advisor && (
          <p className={isDark ? "dark-mode card-advisor" : "card-advisor"}>
            {cardInfo.advisor}
          </p>
        )}
      </div>
      {cardInfo.footer && cardInfo.footer.length > 0 && (
        <div className="certificate-card-footer">
          {cardInfo.footer.map((v, i) => {
            return (
              <span
                key={i}
                className={
                  isDark ? "dark-mode certificate-tag" : "certificate-tag"
                }
                onClick={() => openUrlInNewTab(v.url, v.name)}
              >
                {v.name}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}
